import { EvaluationProps } from '@/widgets/types/evaluationProps';
import { QuestionScoreMode } from '@/widgets/types/questionScoreMode';

export const getEvaluationProps = (isPlenaryLesson: boolean): EvaluationProps => ({
  questionScoreMode: isPlenaryLesson ? QuestionScoreMode.WithoutScore : QuestionScoreMode.WithScore,
  showAnswerButton: true,
  showHintButton: false,
  showIndicatorButton: false
});
